import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { FormProvider, RHFTextField } from "../components/hook-form";
import { Link, useNavigate } from "react-router-dom";
import { initiateAuth, login, loginUser } from "../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../components/Spinner";
import qs from "qs";

import { useTranslation } from "react-i18next";
import { getProfileInfo } from "../redux/actions/profileActions";

const Login = () => {
  const { t } = useTranslation();
  const LoginSchema = Yup.object().shape({
    password: Yup.string()
      .required()

      .min(6)
      .max(12),
    email: Yup.string().required(),
  });

  const defaultValues = {
    email: "",
    password: "",

    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, loading, error, msg } = useSelector((state) => state.Auth);
  const onSubmit = async (values) => {
    // loginUser(values);
    console.log(values);
    dispatch(loginUser(values));
  };

  useEffect(() => {
    if (user?.token) navigate("/", { replace: true });
  }, [user, navigate]);

  return (
    <div className=" min-h-screen rounded-sm ">
      <div className="w-full text-center  h mx-auto grid place-items-center md:grid-cols-12 min-h-screen ">
        <img src="/lover.jpg" className=" animate-pulse md:col-span-7" alt="" />

        <div
          className=" md:col-span-5"
          style={{
            backgroundImage: "url(/lllove.svg)",
            backgroundSize: "contain",
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
          }}>
          <h2
            style={{ fontFamily: "'Kaushan Script', cursive " }}
            className="text-6xl mb-10 text-pink-400 text-center">
            welcome to heartlink
          </h2>
          <FormProvider
            methods={methods}
            classes=" shadow-lg border-slate-100 rounded-lg p-6 mt-4  bg-white"
            onSubmit={handleSubmit(onSubmit)}
            // style={{background: "url(/lllove.svg)"}}
          >
            <p className="text-pink-900 text-center">
              {typeof error === "string" ? error : error?.errors[0].msg}
            </p>
            <p className="text-pink-900 text-center">{msg}</p>

            <RHFTextField
              type="email"
              label={t("email")}
              placeholder="please enter your email"
              name="email"
              classes="bg-pink-50"
            />
            <RHFTextField
              type="password"
              label={t("password")}
              placeholder="please enter your password"
              name="password"
              classes="bg-pink-50"
              autocomplete="new-password"
            />

            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-pink-600 text-white rounded shadow w-full p-2 mb-2 mt-4"
                // disabled={loading}
              >
                <Spinner loading={loading} text={t("login")} />
              </button>
            </div>
            <Link to="/auth/register" className="text-pink-400 animate-pulse">
              Create a new Account
            </Link>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Login;
